import { jsx as c } from "react/jsx-runtime";
import d from "moment";
import { t as g } from "../../../bundle-mjs-DoW15_-f.js";
import { isDateInRange as M, Views as b } from "../../../utils/datepicker.js";
import { useDatePickerContext as f } from "../DatepickerContext.js";
const x = () => {
  const {
    theme: l,
    minDate: m,
    maxDate: a,
    selectedDate: n,
    viewDate: D,
    setViewDate: h,
    setView: p
  } = f(), t = l.views.months;
  return /* @__PURE__ */ c("div", { className: t.items.base, children: [...Array(12)].map((y, s) => {
    const e = new Date(D.getTime());
    e.setDate(1), e.setMonth(s);
    const w = d().month(s).format("MMM"), u = n?.getFullYear() === e.getFullYear() && n?.getMonth() === e.getMonth(), i = m ? new Date(m.getTime()) : null, r = a ? new Date(a.getTime()) : null;
    i?.setDate(1), r?.setDate(1);
    const o = !M(
      e,
      i,
      r
    );
    return /* @__PURE__ */ c(
      "button",
      {
        disabled: o,
        type: "button",
        className: g(
          t.items.item.base,
          u && t.items.item.selected,
          o && t.items.item.disabled
        ),
        onClick: () => {
          o || (h(e), p(b.Days));
        },
        children: w
      },
      s
    );
  }) });
};
export {
  x as DatepickerViewsMonth
};
